// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__hc58Z","input":"style_input__U6GaN"};